/* Core by Chloe Pilates — the bag (November 2026).
   Brings the Build your 4-pack rail to life: when pairs are added, the new packs drop onto their hooks and
   swing, the counter bumps, the CC shopping bag by the heading hops, and the fourth pair stamps
   "Pack complete" with a little burst of stars.
   It remembers what the shopper last saw on this visit (sessionStorage), so packs only drop when they are new.
   After an add, the theme refreshes the bag a second time a moment later (cart.js onCartUpdate); the rail then
   picks the animation up where it was rather than cutting it off.
   People who have turned on reduced motion get the finished rail with no movement. */
(function () {
  if (window.customElements.get('cbc-pack')) return;
  var KEY = 'cbcBagPack';
  var REPLAY_MS = 3000;
  var STEP = 0.14;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function read() {
    try {
      var v = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      return v && typeof v.p === 'number' ? v : { p: 0, f: false, a: null };
    } catch (e) {
      return null;
    }
  }
  function write(state) {
    try { window.sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  window.customElements.define('cbc-pack', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-preview')) { write({ p: 0, f: false, a: null }); return; }
      var now = parseInt(this.getAttribute('data-pairs'), 10) || 0;
      var full = this.getAttribute('data-full') === 'true';
      var before = read();
      if (reduce || !before) { write({ p: now, f: full, a: null }); return; }

      // The same bag, re-rendered moments after an add: carry on with the animation already playing.
      var a = before.a;
      if (a && before.p === now && before.f === full && Date.now() - a.t < REPLAY_MS) {
        this.play(a.from, now, a.cel, (Date.now() - a.t) / 1000);
        return;
      }

      var added = now > before.p;
      var celebrate = full && !before.f;
      if (!added && !celebrate) { write({ p: now, f: full, a: null }); return; }
      var from = added ? before.p : now;
      write({ p: now, f: full, a: { from: from, cel: celebrate, t: Date.now() } });
      this.play(from, now, celebrate, 0);
    }

    play(from, now, celebrate, elapsed) {
      this.style.setProperty('--el', elapsed.toFixed(3) + 's');
      var k = 0;
      if (now > from) {
        var slots = this.querySelectorAll('.cbp-slot.is-filled');
        for (var i = Math.min(from, 4); i < Math.min(now, 4); i++) {
          if (!slots[i]) break;
          slots[i].style.setProperty('--d', (k * STEP) + 's');
          slots[i].classList.add('is-new');
          k++;
        }
        var count = this.querySelector('.cbp-count');
        if (count) {
          count.style.setProperty('--bump', (0.5 + Math.max(k - 1, 0) * STEP + 0.45) + 's');
          count.classList.add('is-bump');
        }
        var inner = this.closest('.drawer__inner');
        var mark = inner && inner.querySelector('.cbb-bagmark');
        if (mark && !mark.classList.contains('is-hop')) {
          mark.style.setProperty('--el', elapsed.toFixed(3) + 's');
          mark.style.setProperty('--hop', (0.5 + Math.max(k - 1, 0) * STEP + 0.3) + 's');
          mark.classList.add('is-hop');
        }
      }
      if (celebrate) {
        this.style.setProperty('--dl', (0.5 + Math.max(k - 1, 0) * STEP + (k ? 0.75 : 0.1)) + 's');
        this.classList.add('is-celebrate');
      }
    }
  });
})();
